module.exports = __webpack_public_path__ + "static/media/icon-play.4937e270.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-play.png
// module id = 1886
// module chunks = 6